import React from 'react';
import styles from './styles';
import axios from 'axios'
import axiosConfig from '../../config/axios.config';
import {UserContext} from '../../Context/UserContext';
import {InstanceContext} from '../../InstanceContext';
import { trackError, trackActivity } from '../../utils/activityTracker'
import { checkResponseErrorCodeAndRedirect } from '../../utils/errorHelper'

const Admin = (props) => {
  const {user} = React.useContext(UserContext);
  const {contextInstance} = React.useContext(InstanceContext);
  const instance = contextInstance || user.instance;

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    });
  }

  const handleNewsletter = e => {
    console.log(e.target, e.target.id, instance,  "TARG")
    handleActivityLogUpdate(`Admin.handleNewsletter`)
    // removed 'axiosConfig.auth' as token is updated on login
    axios.get(`${axiosConfig.apiUrl}/rt/console/newsletter/${instance}/${e.target.id}`).then(response => {
      console.log(response)
    }).catch((err) => {
      console.log(err)
      trackError({ error: err, history: props.history })
      checkResponseErrorCodeAndRedirect(err);
    })
  }

  const handleFollowUp = e => {
    console.log(e.target, e.target.id, instance,  "TARG")
    handleActivityLogUpdate(`Admin.handleFollowUp`)
    axios.get(`${axiosConfig.apiUrl}/email-triage/${e.target.id}/${instance}`).then(response => {
      console.log(response)
    }).catch((err) => {
      console.log(err)
      trackError({ error: err, history: props.history })
      checkResponseErrorCodeAndRedirect(err);
    })
  }


  return <div style={styles.container}>
    <div style={styles.panel}>
      <p style={styles.heading}>New trial notifications for {instance}</p>
      <button
        onClick={handleNewsletter}
        styles={styles.button}
        id="ADMIN"
      >
        Send ADMIN New Trials Notification
      </button>
      <button
        onClick={handleNewsletter}
        styles={styles.button}
        id="USERS"
      >
        Send USERS New Trials Notification
      </button>
      <button
          onClick={handleFollowUp}
          styles={styles.button}
          id="send"
      >
        Send USERS Referral Follow Up
      </button>
      <button
          onClick={handleFollowUp}
          styles={styles.button}
          id="notify-admin"
      >
        Send ADMIN Referral Follow Up Update
      </button>
    </div>
    <div style={styles.panel}>
      <p style={styles.heading}>Rebuild Elastic Search</p>
    </div>
  </div>
}

export default Admin;
